// extracted by mini-css-extract-plugin
module.exports = {"helin":"helin-ulas-module--helin--1HRVN","audio":"helin-ulas-module--audio--1jhQF","info":"helin-ulas-module--info--JszuI"};